import isTypeOf from './isTypeOf';
const isString = isTypeOf('string');
export default isString;
